import { ajax } from "@/utils/request";
const api = {
    // 材料总计划
    getMasterPlan(data: any) {
        return ajax({
            method: "get",
            url: `material-total-plan-mgt/plan-page`,
            data,
        });
    },

    // 获取项目经理
    getProjectManager() {
        return ajax({
            method: "get",
            url: `project-mgt/project-manager`,
        });
    },

    // 获取材料信息分页列表
    getMaterialsPaging(data: any) {
        return ajax({
            method: "get",
            url: `material-mgt/materials`,
            data,
        });
    },

    // 材料分类树
    getMaterialClass(data: any) {
        return ajax({
            method: "get",
            url: `material-mgt/classifies`,
        });
    },

    // 项目信息分页
    getProjectsPaging(data: any) {
        return ajax({
            method: "get",
            url: `project-mgt/projects`,
            data,
        });
    },

    // 获取项目信息
    getProjectsDetaill(id: string) {
        return ajax({
            method: "get",
            url: `project-bid-mgt/projects/${id}`,
        });
    },

    /****************************************************************
     *
     * @通用部分
     *
     ***************************************************************/
    // 供应商查询
    getSuppliersList(data: any) {
        return ajax({
            method: "GET",
            url: `supplier-mgt/suppliers`,
            data,
        });
    },

    // 获取供应商下拉列表
    getSupplierSelectList(data: any) {
        return ajax({
            method: "GET",
            url: `supplier-mgt/supplier-select`,
            data,
        });
    },

    // 获取项目列表
    getProjectList() {
        return ajax({
            method: "get",
            url: `project-mgt/select-project-list`,
        });
    },

    // 项目班组列表查询
    getProjiectTeamList() {
        return ajax({
            method: "GET",
            url: `labour-class-member/query-project-class-list`,
        });
    },
    // 项目班组移除
    removeLabourForProject(query: any){
        return ajax({
            method: "POST",
            url: `labour-class-member/remove`,
            data: query
        });
    },

    // 项目供应商树
    getSuppliersTree(contractType: any) {
        return ajax({
            method: "GET",
            url: `supplier-mgt/project-suppliers?contractType=${contractType}`,
        });
    },

    // 项目劳务班组列表查询
    getLabourProject(projectId: any) {
        return ajax({
            method: "GET",
            url: `labour-class-member/query-project-class-list/${projectId}`,
        });
    },
    // 项目双包班组列表查询
    getDoubleProjectSupplier(projectId: any) {
        return ajax({
            method: "GET",
            url: `labour-supplier-mgt/get-project-supplier/${projectId}`,
        });
    },


    /****************************************************************
     *
     * @材料总计划 get add edit ext apply remove material
     *
     ***************************************************************/

    // 新增材料总计划 POST
    addMaterialPlans(data: any) {
        return ajax({
            method: "POST",
            url: `material-total-plan-mgt/plans`,
            data,
        });
    },

    // 修改材料总计划 PUT
    editMaterialPlans(data: any, id?: string | number) {
        return ajax({
            method: "PUT",
            url: `material-total-plan-mgt/plan/${id || data.id}`,
            data,
        });
    },

    // 获取材料总计划详情 GET
    getMaterialPlansDetail(id: string | number) {
        return ajax({
            method: "GET",
            url: `material-total-plan-mgt/plan/${id}`,
        });
    },

    // 材料总计划申请退回 PUT
    backMaterialPlans(id: string | number) {
        return ajax({
            method: "PUT",
            url: `material-total-plan-mgt/plan/${id}/back`,
        });
    },

    // 材料总计划申请作废 PUT
    cancelMaterialPlans(id: string | number) {
        return ajax({
            method: "PUT",
            url: `material-total-plan-mgt/plan/${id}/cancel`,
        });
    },

    // 材料总计划申请审核通过 PUT
    passMaterialPlans(data: any) {
        return ajax({
            method: "PUT",
            url: `material-total-plan-mgt/plan/pass`,
            data,
        });
    },

    // 材料总计划申请审核不通过 PUT
    rejectMaterialPlans(data: any) {
        return ajax({
            method: "PUT",
            url: `material-total-plan-mgt/plan/reject`,
            data,
        });
    },

    // 材料总计划分页查询 GET
    getMaterialPlansPaging(data: any) {
        return ajax({
            method: "GET",
            url: `material-total-plan-mgt/plan-page`,
            data,
        });
    },

    // 材料总计划列表统计 GET
    getMaterialPlansStatistic(data: any) {
        return ajax({
            method: "GET",
            url: `material-total-plan-mgt/plan-sum`,
            data,
        });
    },

    // 材料总计划材料 GET
    getMaterialPlansMaterial(data: any) {
        return ajax({
            method: "get",
            url: `material-total-plan-mgt/plan-material-page/${data.projectId}`,
            data,
        });
    },

    // 导出列表 GET
    extMaterialPlans(data: any) {
        return ajax({
            method: "GET",
            url: `material-total-plan-mgt/plans/export`,
            data,
            type: "blob",
        });
    },

    // 获取品牌列表 GET
    getBrandList() {
        return ajax({
            method: "GET",
            url: `brand-mgt/select-brand-list`,
        });
    },

    /****************************************************************
     *
     * @材料分批计划 get add edit ext apply remove material
     *
     ***************************************************************/
    // 新增材料分批计划
    addMaterialSubPlans(data: any) {
        return ajax({
            method: "POST",
            url: `material-sub-plan-mgt/plans`,
            data,
        });
    },
    // 修改材料分批计划
    editMaterialSubPlans(data: any) {
        return ajax({
            method: "PUT",
            url: `material-sub-plan-mgt/plan/${data.id}`,
            data,
        });
    },
    // 获取材料分批计划详情
    getMaterialSubPlansDetail(id: any) {
        return ajax({
            method: "GET",
            url: `material-sub-plan-mgt/plan/${id}`,
        });
    },
    // 材料分批计划申请退回
    backMaterialSubPlans(id: string | number) {
        return ajax({
            method: "PUT",
            url: `material-sub-plan-mgt/plan/${id}/back`,
        });
    },
    // 材料分批计划申请作废
    cancelMaterialSubPlans(id: string | number) {
        return ajax({
            method: "PUT",
            url: `material-sub-plan-mgt/plan/${id}/cancel`,
        });
    },
    // 材料分批计划申请审核通过
    passMaterialSubPlans(data: any) {
        return ajax({
            method: "PUT",
            url: `material-sub-plan-mgt/plan/pass`,
            data,
        });
    },
    // 材料分批计划申请审核不通过
    rejectMaterialSubPlans(data: any) {
        return ajax({
            method: "PUT",
            url: `material-sub-plan-mgt/plan/reject`,
            data,
        });
    },
    // 材料分批计划分页查询
    // 材料分批计划列表统计
    // 导出列表
    extMaterialSubPlans(data: any) {
        return ajax({
            method: "GET",
            url: `material-sub-plan-mgt/plans/export`,
            data,
            type: "blob",
        });
    },
    // 材料分批计划材料
    getMaterialSubPlansMaterial(data: any) {
        return ajax({
            method: "get",
            url: `material-sub-plan-mgt/plan-material-page/${data.projectId}`,
            data,
        });
    },


    /****************************************************************
     *
     * @材料入库 get add edit ext apply remove material
     *
     ***************************************************************/
    // 新增材料入库信息
    // 获取材料入库详情
    getMaterialsEntryDetail(id: any) {
        return ajax({
            method: "GET",
            url: `material-in-mgt/materials/${id}`,
        });
    },
    // 分页查询
    getMaterialEntryPaging(data: any) {
        return ajax({
            method: "GET",
            url: `material-in-mgt/material`,
            data,
        });
    },
    // 采购入库材料查询
    // 调拨入库材料查询
    // 生成领料单
    // 导出入库单

    /****************************************************************
     *
     * @材料出库 get add edit ext apply remove material
     *
     ***************************************************************/
    // 新增材料出库信息
    // 获取材料出库详情
    getMaterialsOutDetail(id: any) {
        return ajax({
            method: "GET",
            url: `material-out-mgt/materials/${id}`,
        });
    },
    // 分页查询
    getMaterialOutPaging(data: any) {
        return ajax({
            method: "GET",
            url: `material-out-mgt/material`,
            data,
        });
    },
    // 查询材料选择列表

    /****************************************************************
     *
     * @合同管理 get add edit ext apply remove material
     *
     ***************************************************************/
    // 合同分页查询

    /****************************************************************
     *
     * @班组管理 get add edit ext apply remove material
     *
     ***************************************************************/
    // 班组分页查询 get
    getLabourTeamPaging(data: any) {
        return ajax({
            method: "GET",
            url: `labour-class/list`,
            data,
        });
    },
    
    // 导出工人
    exportWork(data: any){
        return ajax({
            method: "GET",
            url: `labour-class-member/list/export`,
            data,
            type: "blob"
        });
    },

    // 添加工人信息
    appendWorker(data: any) {
        return ajax({
            method: "POST",
            url: `labour/create`,
            data,
        });
    },

    // 修改工人信息
    editWorker(data: any) {
        return ajax({
            method: "POST",
            url: `labour/update/${data.id}`,
            data,
        });
    },

    // 获取工人列表
    getLabourSupplierList(data: any) {
        return ajax({
            method: "GET",
            url: `labour-supplier-mgt/get-labour-list`,
            data,
        });
    },

    // 获取工人详细信息
    getWorkerDetail(id: any) {
        return ajax({
            method: "GET",
            url: `labour/get/${id}`,
        });
    },

    // 班组列表
    getTeamLabourList(data: any) {
        return ajax({
            method: "GET",
            url: `labour-class/select-list`,
            data
        });
    },

    // 班组创建
    createLabourTeam(data: any) {
        return ajax({
            method: "POST",
            url: `labour-class/create`,
            data
        });
    },

    // 班组修改
    editLabourTeam(data: any) {
        return ajax({
            method: "POST",
            url: `labour-class/update/${data.id}`,
            data
        });
    },
    // 修改劳务班组详情
    getLabourTeamDetail(id: any) {
        return ajax({
            method: "get",
            url: `labour-class/get/${id}`,
        });
    },
    // 工人列表查询
    getlabourWokermanList(data: any) {
        return ajax({
            method: "get",
            url: `labour/list`,
            data
        });
    },


    /****************************************************************
     *
     * @劳务公司管理 get add edit ext apply remove material
     *
     ***************************************************************/
    // 分页查询
    getLabourCompanyList(data: any){
        return ajax({
            method: "get",
            url: `labour-company-mgt/company`,
            data
        });
    },
    // 新增
    labourCompanyAdd(data: any){
        return ajax({
            method: "post",
            url: `labour-company-mgt/company`,
            data
        });
    },
    // 编辑
    labourCompanyEdit(data: any){
        return ajax({
            method: "put",
            url: `labour-company-mgt/company/${data.id}`,
            data
        });
    },
    // 删除
    labourCompanyDelete(data: any){
        return ajax({
            method: "delete",
            url: `labour-company-mgt/company/${data}`,
            data
        });
    },
    // 详情
    labourCompanyDetail(data: any){
        return ajax({
            method: "get",
            url: `labour-company-mgt/company/${data}`,
            data
        });
    },
    // 启用
    labourCompanyEnable(data: any){
        return ajax({
            method: "put",
            url: `labour-company-mgt/company/enable/${data}`,
        });
    },
    // 禁用
    labourCompanyDisable(data: any){
        return ajax({
            method: "put",
            url: `labour-company-mgt/company/disable/${data}`,
        });
    },
    // 导出
    labourCompanyExport(data: any){
        return ajax({
            method: "get",
            url: `labour-company-mgt/export`,
            data,
            type: "blob",
        });
    },
    // 下拉选择
    labourCompanyListData(){
        return ajax({
            method: "get",
            url: `labour-company-mgt/select-list`,
        });
    },



    /****************************************************************
     *
     * @工程任务单管理 get add edit ext apply remove material
     *
     ***************************************************************/

    /****************************************************************
     *
     * @材料台账 get add edit ext apply remove material
     *
     ***************************************************************/
    // 分页查询 get
    getMaterialStockList(data: any) {
        return ajax({
            method: "GET",
            url: `material-stock-mgt/stock`,
            data,
        });
    },

    /****************************************************************
     *
     * @劳务管理 get add edit ext apply remove material
     *
     ***************************************************************/
    // 合同分页查询
    getContractPaging(data: any) {
        return ajax({
            method: "GET",
            url: `contract-apply/contracts`,
            data,
        });
    },
    // 新增劳务班组
    addLabourClass(projectId: any, data: any){
        return ajax({
            method: "POST",
            url: `project-class-mgt/project-labour/${projectId}`,
            data,
        });
    },
    // 移除劳务班组
    deleLabourClass(projectId: any, classId: any){
        return ajax({
            method: "DELETE",
            url: `project-class-mgt/project-labour/${projectId}/${classId}`,
        });
    },
    // 新增双包班组
    addDoubleClass(projectId: any, data: any){
        return ajax({
            method: "POST",
            url: `project-class-mgt/project-double/${projectId}`,
            data,
        });
    },
    // 移除双包班组
    deleDoubleClass(projectId: any, classId: any){
        return ajax({
            method: "DELETE",
            url: `project-class-mgt/project-double/${projectId}/${classId}`,
        });
    },

    /****************************************************************
     *
     * @双包管理 get add edit ext apply remove material
     *
     ***************************************************************/
    // 获取任务清单详情
    getdoubleTaskDetail(data: any) {
        return ajax({
            method: "GET",
            url: `double-task/get`,
            data,
        });
    },

    // 工程任务完成情况
    getdoubleTaskState(data: any) {
        return ajax({
            method: "GET",
            url: `double-task/query-task`,
            data,
        });
    },

    // 保存任务清单
    saveDoubleTask(data: any) {
        return ajax({
            method: "POST",
            url: `double-task/save`,
            data,
        });
    },

    /****************************************************************
    *
    * @付款计划 get add edit ext apply remove material
    *
    ***************************************************************/
    //    分页查询
    getPaymentPaging(data: any) {
        return ajax({
            method: "GET",
            url: `payment-plan/list`,
            data,
        });
    },

    // 材料供应商查询
    getMaterialSupplier(data: any) {
        return ajax({
            method: "GET",
            url: `purchase-mgt/material-supplier`,
            data,
        });
    },

    ///////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////

    /****************************************************************
    *
    * @合同申请通用 get add edit ext apply remove material
    *
    ***************************************************************/
    //    客户信息列表
    getCustomer(data?: any) {
        return ajax({
            method: "GET",
            url: `customer-mgt/select-customer-list`,
            data,
        });
    },

    // 创建业主合同
    createOwner(data: any) {
        return ajax({
            method: "POST",
            url: `contract-apply/create-owner-contract`,
            data,
        });
    },

    // 修改业主合同
    editOwner(data: any) {
        return ajax({
            method: "POST",
            url: `contract-apply/update-owner-contract/${data.id}`,
            data,
        });
    },

    // 创建劳务合同
    createLabour(data: any) {
        return ajax({
            method: "POST",
            url: `contract-apply/create-labour-contract`,
            data,
        });
    },

    // 修改劳务合同
    editLabour(data: any) {
        return ajax({
            method: "POST",
            url: `contract-apply/update-labour-contract/${data.id}`,
            data,
        });
    },

    // 创建材料合同
    createMaterialContract(data: any) {
        return ajax({
            method: "POST",
            url: `contract-apply/create-material-contract`,
            data,
        });
    },

    // 修改材料合同
    editMaterialContract(data: any) {
        return ajax({
            method: "POST",
            url: `contract-apply/update-material-contract/${data.id}`,
            data,
        });
    },

    // 创建双包合同
    createDoubleContract(data: any) {
        return ajax({
            method: "POST",
            url: `contract-apply/create-double-contract`,
            data,
        });
    },

    // 修改双包合同
    editDoubleContract(data: any) {
        return ajax({
            method: "POST",
            url: `contract-apply/update-double-contract/${data.id}`,
            data,
        });
    },

    // 创建专项分包合同
    createSpeciallyContract(data: any) {
        return ajax({
            method: "POST",
            url: `contract-apply/create-specially-contract`,
            data,
        });
    },
    // 修改专项分包合同
    editSpeciallyContract(data: any) {
        return ajax({
            method: "POST",
            url: `contract-apply/update-specially-contract/${data.id}`,
            data,
        });
    },

    // 创建一般合同
    createCommonContract(data: any) {
        return ajax({
            method: "POST",
            url: `contract-apply/create-common-contract`,
            data,
        });
    },

    // 修改一般合同
    editCommonContract(data: any) {
        return ajax({
            method: "POST",
            url: `contract-apply/update-common-contract/${data.id}`,
            data,
        });
    },

    // 下载劳务合同工程任务单模板
    getLabourContractTemplate(){
        return ajax({
            method: "GET",
            url: `contract-apply/template-labour-details`,
            type: "blob",
        });
    },

    // 合同详情
    getContractDetail(id: any) {
        return ajax({
            method: "GET",
            url: `contract-apply/${id}`,
        });
    },

    // 合同统计
    getContractCount(data: any) {
        return ajax({
            method: "GET",
            url: `contract-apply/contracts-count`,
            data
        });
    },

    // 合同同意
    contractComplete(data: any) {
        return ajax({
            method: "POST",
            url: `process-task-mgt/complete`,
            data
        });
    },

    // 材料总计划分页查询
    getMaterialMasterPlanPaging(data: any) {
        return ajax({
            method: "GET",
            url: `material-total-plan-mgt/plan-page`,
            data,
        });
    },
    // 材料总计划列表统计
    getMaterialMasterPlanCount(data: any) {
        return ajax({
            method: "GET",
            url: `material-total-plan-mgt/plan-sum`,
            data,
        });
    },

    // 材料分批计划分页查询
    getMaterialBranchPlanPaging(data: any) {
        return ajax({
            method: "GET",
            url: `material-sub-plan-mgt/plan-page`,
            data,
        });
    },
    // 材料分批计划列表统计
    getMaterialBranchPlanCount(data: any) {
        return ajax({
            method: "GET",
            url: `material-sub-plan-mgt/plan-sum`,
            data,
        });
    },

    // 材料分批计划收货人列表
    getMaterialBranchPlayConcatList(){
        return ajax({
            method: "GET",
            url: `material-sub-plan-mgt/consignee-list`,
        });
    },
    
    // 材料分批计划使用部位列表
    getMaterialBranchPlayUsePart(){
        return ajax({
            method: "GET",
            url: `material-sub-plan-mgt/userpart-list`,
        });
    },
    // 采购申请分页查询
    getPayApplyPaging(data: any) {
        return ajax({
            method: "GET",
            url: `purchase-mgt/purchase-page`,
            data,
        });
    },

    // 采购申请列表统计
    getPayApplyCount(data: any) {
        return ajax({
            method: "GET",
            url: `purchase-mgt/purchase-sum`,
            data,
        });
    },

    // 材料分批计划材料
    getMaterialPlan(data: any,) {
        return ajax({
            method: "GET",
            url: `material-sub-plan-mgt/plan-material-page/${data.projectId}`,
            data,
        });
    },

    // 修改项目信息
    editProjectsInfo(data: any) {
        return ajax({
            method: "PUT",
            url: `project-mgt/projects/${data.id}`,
            data,
        });
    },

    // 添加付款计划
    addPaymentPlan(data: any) {
        return ajax({
            method: "POST",
            url: `payment-plan/create`,
            data,
        })
    },

    // 获取付款计划详细信息
    getPaymentPlanDetail(planNo: any) {
        return ajax({
            method: "GET",
            url: `payment-plan/get/${planNo}`,
        })
    },

    // 修改付款计划
    editPaymentPlan(data: any) {
        return ajax({
            method: "POST",
            url: `payment-plan/update`,
            data
        })
    },

    // 移除付款计划
    removePaymentPlan(planNo: any) {
        return ajax({
            method: "POST",
            url: `payment-plan/remove/${planNo}`,
        })
    },

    // 新增采购申请
    addPurchases(data: any) {
        return ajax({
            method: "POST",
            url: `purchase-mgt/purchases`,
            data,
        })
    },

    // 修改采购申请
    editPurchases(data: any) {
        return ajax({
            method: "PUT",
            url: `purchase-mgt/purchase/${data.id}`,
            data,
        })
    },
    // 获取采购申请详情
    getPurchasesDetail(id: any) {
        return ajax({
            method: "GET",
            url: `purchase-mgt/purchase/${id}`,
        })
    },
    // 获取材料最低价列表
    getPurchaseMinPriceList(data: any){
        return ajax({
            method: "GET",
            url: `purchase-mgt/get-material-min-price`,
            data
        })
    },

    // 采购申请申请退回
    // 采购申请作废
    // 采购申请审核不通过
    rejectPurchases(data: any) {
        return ajax({
            method: "PUT",
            url: `purchase-mgt/reject`,
            data
        })
    },
    // 通过
    completePurchases(data: any) {
        return ajax({
            method: "POST",
            url: `purchase-mgt/complete`,
            data
        })
    },


    // 工程部 - 劳务管理
    // 列表查询
    getLabourClassList(data: any) {
        return ajax({
            method: "GET",
            url: `labour-class-member/list`,
            data
        })
    },

    // 移除工人
    removeLabour(id: any) {
        return ajax({
            method: "POST",
            url: `labour/remove/${id}`,
        })
    },

    // 合同申请退回
    contractWithdraw(id: any) {
        return ajax({
            method: "PUT",
            url: `contract-apply/withdraw/${id}`,
        })
    },

    // 合同作废
    contractInvalid(id: any) {
        return ajax({
            method: "PUT",
            url: `contract-apply/invalid/${id}`,
        })
    },

    // 导出合同申请
    contractExport(id: any) {
        return ajax({
            method: "GET",
            url: `contract-apply/export-contract/${id}`,
            type: "blob",
        })
    },

    // 导出合同申请
    contractExportList(data: any) {
        return ajax({
            method: "GET",
            url: `contract-apply/export-contract-list`,
            type: "blob",
            data
        })
    },

    // 采购导出列表
    exportPurchaseList(data: any) {
        return ajax({
            method: "GET",
            url: `purchase-mgt/purchase/export`,
            type: "blob",
            data
        })
    },

    // 采购列表退还
    purchaseWithdraw(id: any) {
        return ajax({
            method: "PUT",
            url: `purchase-mgt/${id}/back`,
        })
    },

    // 采购列表作废
    purchaseInvalid(id: any) {
        return ajax({
            method: "PUT",
            url: `purchase-mgt/${id}/cancel`,
        })
    },

    // 采购导pdf
    exportPurchasePdf(id: number) {
        return ajax({
            method: "GET",
            url: `purchase-mgt/export/${id}`,
            type: "blob",
        })
    },

    // 材料总计划导出pdf
    exportMaterialTotalPdf(id: number) {
        return ajax({
            method: "GET",
            url: `material-total-plan-mgt/export/${id}`,
            type: "blob",
        })
    },

    // 材料总计划导出word
    exportMaterialTotalWord(id: number) {
        return ajax({
            method: "GET",
            url: `material-total-plan-mgt/export-word/${id}`,
            type: "blob",
        })
    },
    /****************************************************************
     *
     * @资料管理 get add edit ext apply remove material
     *
     ***************************************************************/
    // 资料列表
    getDataPlanList(data: any) {
        return ajax({
            method: "get",
            url: `data-plan-mgt/list`,
            data
        })
    },
    // 取消上传
    cancelDataPlan(id: any) {
        return ajax({
            method: "post",
            url: `data-plan-mgt/cancel-upload/${id}`,
        })
    },
    // 创建资料
    createDataPlan(data: any) {
        return ajax({
            method: "post",
            url: `data-plan-mgt/create`,
            data
        })
    },
    // 移除资料
    deleteDataPlan(id: any) {
        return ajax({
            method: "post",
            url: `data-plan-mgt/remove/${id}`,
        })
    },
    // 更新资料
    updateDataPlan(data: any) {
        return ajax({
            method: "post",
            url: `data-plan-mgt/update`,
            data
        })
    },
    // 上传资料
    uploadDataPlan(data: any) {
        return ajax({
            method: "post",
            url: `data-plan-mgt/upload`,
            data
        })
    },
    // 资料详情
    detailDataPlan(id: any) {
        return ajax({
            method: "get",
            url: `data-plan-mgt/data/${id}`,
        })
    },

    // 供应商下拉列表
    getSupplierSelect() {
        return ajax({
            method: "GET",
            url: `supplier-mgt/supplier-select`,
        })
    },

    // 根据所属项目查供应商 
    getProjectSupplierSelect(data: any) {
        return ajax({
            data,
            method: "GET",
            url: `supplier-mgt/project-suppliers-select`,
        })
    },

    // 劳务工程单详情
    getLabourTaskDetails(data: any) {
        return ajax({
            data,
            method: "GET",
            url: `labour-task/get`,
        })
    },

    // 劳务工程单完成情况
    getLabourTaskState(data: any) {
        return ajax({
            data,
            method: "GET",
            url: `labour-task/query-task`,
        })
    },

    // 保存工程任务单
    saveLabourTask(data: any) {
        return ajax({
            data,
            method: "POST",
            url: `labour-task/save`,
        })
    },

    // 保存工程任务单
    exportLabourTask(data: any) {
        return ajax({
            method: "GET",
            url: `labour-task/export`,
            type: "blob",
            data
        })
    },

    // 移除班组
    removeLabourClass(labourClassId: any) {
        return ajax({
            method: "POST",
            url: `labour-class/remove/${labourClassId}`,
        })
    },
    // 启用班组
    enableLabourClass(labourClassId: any) {
        return ajax({
            method: "POST",
            url: `labour-class/enabled/${labourClassId}`,
        })
    },
    // 禁用班组
    disableLabourClass(labourClassId: any) {
        return ajax({
            method: "POST",
            url: `labour-class/disabled/${labourClassId}`,
        })
    },

    // 分批计划下载
    exportMaterialSubPdf(id: any) {
        return ajax({
            method: "GET",
            url: `material-sub-plan-mgt/export/${id}`,
            type: "blob",
        })
    },
    // 分批计划WORD下载
    exportMaterialSubWord(id: any) {
        return ajax({
            method: "GET",
            url: `material-sub-plan-mgt/export-word/${id}`,
            type: "blob",
        })
    },

    // 下载入库单
    exportMaterialEntry(id: any) {
        return ajax({
            method: "GET",
            url: `material-in-mgt/export/${id}`,
            type: "blob",
        })
    },


    // 下载出库单
    exportMaterialOut(id: any) {
        return ajax({
            method: "GET",
            url: `material-in-mgt/export/${id}`,
            type: "blob",
        })
    },

    // 从劳务资源库导入 
    importLabour(data: any) {
        return ajax({
            method: "POST",
            url: `labour-class-member/batch-import`,
            data
        })
    },

    // 下载班组模板
    dowLabourTemplate() {
        return ajax({
            method: "GET",
            url: `labour-class/template`,
            type: "blob",
        })
    },

    // 工人模板下载
    dowLabourWorkmanTemplate() {
        return ajax({
            method: "GET",
            url: `labour/template`,
            type: "blob",
        })
    },

    // 工人数据下载
    dowLabourWorkman(data:any) {
        return ajax({
            method: "GET",
            url: `labour/export`,
            type: "blob",
            data: data
        })
    },
    // 启用工人
    enableLabour(labourClassId: any) {
        return ajax({
            method: "POST",
            url: `labour/enabled/${labourClassId}`,
        })
    },
    // 禁用工人
    disableLabour(labourClassId: any) {
        return ajax({
            method: "POST",
            url: `labour/disabled/${labourClassId}`,
        })
    },

    // 下载双包任务单 
    dowDoubleTask(data: any) {
        return ajax({
            method: "GET",
            url: `double-task/export`,
            type: "blob",
            data
        })
    },

    // 合同拒绝
    contractReject(data: any) {
        return ajax({
            data,
            method: "PUT",
            url: `contract-apply/rejected/${data.id}`,
        })
    },

    // supplier import 从劳务资源库导入
    supplierImport(data: any) {
        return ajax({
            data,
            method: "POST",
            url: `labour-supplier-mgt/import`,
        })
    }
}

export default api;
